import script from "./DynamicFormField.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicFormField.vue?vue&type=script&setup=true&lang=js"

import "./DynamicFormField.vue?vue&type=style&index=0&id=0c718972&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c718972"]])

export default __exports__